module.exports = __webpack_public_path__ + "static/media/jacuzzi1.31e79bf0.jpg";